exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title-normal .title-normal-font[data-v-fa0c002c]{font-family:Roboto,Helvetica,Arial,sans-serif!important;font-size:16px}.navbar-brand .tab-focus[data-v-fa0c002c]:focus-visible{outline:2px solid grey}.navbar-brand .tab-focus[data-v-fa0c002c],.navbar-brand .tab-focus[data-v-fa0c002c]:hover{border:none!important}", ""]);

// exports
